import React from "react";
import { lePetitPrinceImages } from "../../../../Assets/images/le-petit-prince";
import StyledDiv from "../../../StyledDiv/StyledDiv";
import { IStyledDivStyles } from "../../../StyledDiv/StyledDiv";
import {
  AnimatedCloudBottomLeft,
  AnimatedCloudBottomRight,
} from "../../LandingHeaderHighlightProduct/Decorations/GlobeGreen/CloudAnimation";
import AnimatedStarWrapper from "../../../Decorations/PetitPrince/Star/Variants/AnimatedStarWrapper";

interface IYellowMoonProps {
  styles?: IStyledDivStyles;
}

const YellowMoon = ({ styles }: IYellowMoonProps) => {
  return (
    <StyledDiv styles={styles}>
      <StyledDiv
        styles={{
          position: "relative",
          display: "inline-block",
        }}
      >
        {/* Base element - Yellow Moon */}
        <svg
          width="143"
          height="143"
          viewBox="0 0 143 143"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            position: "relative",
            display: "block",
            zIndex: 1,
          }}
        >
          <circle
            cx="71.2156"
            cy="71.2156"
            r="71.2156"
            fill="url(#paint0_radial_2870_6182)"
          />
          <defs>
            <radialGradient
              id="paint0_radial_2870_6182"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(54.9734 45.9153) rotate(39.6442) scale(113.578)"
            >
              <stop stop-color="#FFF0BF" />
              <stop offset="1" stop-color="#FFD655" />
            </radialGradient>
          </defs>
        </svg>

        {/* Fox - positioned on top of the yellow moon, centered horizontally but lifted vertically */}
        <img
          src={lePetitPrinceImages.fox}
          alt="Fox"
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            transform: "translate(0%, -20%)",
            width: "145px",
            height: "145px",
            zIndex: 2,
          }}
        />

        {/* Small Cloud (54px) - lower-left area, slightly overlapping the moon */}
        <AnimatedCloudBottomLeft
          as="img"
          src={lePetitPrinceImages.cloud}
          alt="Small cloud"
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            transform: "translate(-28%, -82%)",
            width: "54px",
            height: "auto",
            zIndex: 3,
          }}
        />

        {/* Large Cloud (69px) - upper-right area, in the blue sky */}
        <AnimatedCloudBottomRight
          as="img"
          src={lePetitPrinceImages.cloud}
          alt="Large cloud"
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            transform: "translate(72%, 40%)",
            width: "69px",
            height: "auto",
            zIndex: 3,
          }}
        />

        {/* Star Yellow A (22px) - bottom-right quadrant */}
        <AnimatedStarWrapper
          as="img"
          src={lePetitPrinceImages.starYellowA}
          alt="Star yellow A"
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            transform: "translate(60%, -74%)",
            width: "22px",
            height: "auto",
            zIndex: 3,
          }}
          $animationDuration={3}
          $animationDelay={0}
        />

        {/* Star Yellow X (26px) - middle-left quadrant */}
        <AnimatedStarWrapper
          as="img"
          src={lePetitPrinceImages.starYellowX}
          alt="Star yellow X"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            transform: "translate(-125%, 214%)",
            width: "26px",
            height: "auto",
            zIndex: 3,
          }}
          $animationDuration={4}
          $animationDelay={0.2}
        />
      </StyledDiv>
    </StyledDiv>
  );
};

export default YellowMoon;
